export type RichTextAlign = 'center' | 'right';

export type RichTextMark =
  | { type: 'bold' }
  | { type: 'italic' }
  | { type: 'underline' }
  | { type: 'strike' }
  | { type: 'code' }
  | { type: 'link'; attrs: { href: string } };

export type RichTextText = { type: 'text'; text: string; marks?: RichTextMark[] };
export type RichTextHardBreak = { type: 'hardBreak' };
export type RichTextInline = RichTextText | RichTextHardBreak;

export type RichTextParagraph = { type: 'paragraph'; attrs?: { textAlign: RichTextAlign }; content?: RichTextInline[] };
export type RichTextHeading = {
  type: 'heading';
  attrs: { level: 1 | 2 | 3; textAlign?: RichTextAlign };
  content?: RichTextInline[];
};

export type RichTextListItem = { type: 'listItem'; content: RichTextListItemChild[] };
export type RichTextBulletList = { type: 'bulletList'; content: RichTextListItem[] };
export type RichTextOrderedList = { type: 'orderedList'; content: RichTextListItem[] };
export type RichTextList = RichTextBulletList | RichTextOrderedList;
export type RichTextListItemChild = RichTextParagraph | RichTextHeading | RichTextList;
export type RichTextBlock = RichTextParagraph | RichTextHeading | RichTextList;
export type RichTextDoc = { type: 'doc'; content: RichTextBlock[] };

export const EMPTY_RICH_TEXT_DOC: RichTextDoc = { type: 'doc', content: [] };
export const RICH_TEXT_MAX_LIST_DEPTH = 3;
export const RICH_TEXT_MAX_NODES = 50_000;
